import { render, staticRenderFns } from "./AnaliseCoberturaAssessores.vue?vue&type=template&id=51874394&scoped=true&"
import script from "./AnaliseCoberturaAssessores.vue?vue&type=script&lang=js&"
export * from "./AnaliseCoberturaAssessores.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseCoberturaAssessores.vue?vue&type=style&index=0&id=51874394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51874394",
  null
  
)

export default component.exports